import React from 'react';

export interface SummaryFieldProps {
  label: string;
  value: React.ReactNode;
  testId?: string;
}

/**
 * Read-only label/value pair used in preview/summary screens — small label
 * on top, larger value below.
 */
export const SummaryField: React.FC<SummaryFieldProps> = ({
  label,
  value,
  testId,
}) => (
  <div
    className="flex min-w-[140px] flex-1 flex-col gap-1"
    data-testid={testId}
  >
    <p className="text-[11px] font-medium leading-4 text-on-surface-variant">
      {label}
    </p>
    <p className="min-w-0 break-words text-[16px] font-normal leading-6 text-neutral-10">
      {value}
    </p>
  </div>
);

export default SummaryField;
